import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-67592330"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "on-monitor" }
const _hoisted_2 = { class: "second-room" }
const _hoisted_3 = { class: "container" }
const _hoisted_4 = { class: "crumbs" }
const _hoisted_5 = { class: "main" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "detail fl" }
const _hoisted_8 = { class: "d-head" }
const _hoisted_9 = { class: "d-main" }
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = { class: "prev-next clearfix" }
const _hoisted_12 = { class: "on-mobile" }
const _hoisted_13 = { class: "news-detail" }
const _hoisted_14 = { class: "container d-main" }
const _hoisted_15 = { class: "title" }
const _hoisted_16 = { class: "time" }
const _hoisted_17 = ["innerHTML"]

import { useRouter } from "vue-router";
import { newsTypeListHttp, newsDetailHttp } from "@/request/api";
import { ref } from 'vue';
// 目录点击跳转路由事件

export default /*#__PURE__*/_defineComponent({
  __name: 'detail',
  setup(__props) {

// 引入useRouter
const router = useRouter();
// 详情
let currentType = ref<any>(""); // 当前分类ID
let currentActive = ref(true); // 当前分类ID
let detailTitle = ref(""); // 标题
let detailTitleCrumbs = ref(""); // 面包屑文案
let detailContent = ref(""); // 富文本内容
let detailImg = ref(""); // 配图
let detailTime = ref(""); // 发文时间
let detailUser = ref(""); // 作者
// 上下条
let prevId = ref("");
let prevTitle = ref("");
let nextId = ref("");
let nextTitle = ref("");
// 查看新闻上下条
const changeDetail = (type:number)=>{
    if(type == 1){
        toDetail(prevId.value);
    }else{
        toDetail(nextId.value);
    }
    window.scrollTo(0,0);
}
// 点击查看详情
const toDetail = (id:any)=>{
    if(!id) { return }
    newsDetailHttp({id}).then((res:any)=>{
        let {news} = res;
        let { title, content, imgUrl, publishTime, createUser, up, down } = news;
        detailTitle.value = title;
        detailTitleCrumbs.value = title.length>10 ? title.slice(0,12) + '...' : title;
        detailContent.value = content;
        detailImg.value = imgUrl;
        detailTime.value = publishTime;
        detailUser.value = createUser;
        prevId.value = up?.id || "";
        prevTitle.value = up?.title || "";
        nextId.value = down?.id || "";
        nextTitle.value = down?.title || "";
    })
}
// 当前路由信息
let {query} = router.currentRoute.value;
if(query.id){
    let {id,type} = query;
    currentType.value = type;
    currentActive.value = type === "";
    toDetail(id);
}

const toPage = (name:string)=>{
    router.push({name});
}

// 点击新闻类型更新新闻列表
const updateNewsList = (d:string|any)=>{
    router.push({name:"newsList",query:{type: d}});
}
const typeList = ref([] as any[]); // 新闻分类
// 获取新闻分类
newsTypeListHttp().then((res:any)=>{
    let {page} = res;
    let {list} = page;
    typeList.value = list;
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("section", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("p", _hoisted_4, [
            _createElementVNode("span", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (toPage('octopus')))
            }, "首页"),
            _createElementVNode("span", {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (toPage('newsList')))
            }, "新闻中心"),
            _createElementVNode("span", null, _toDisplayString(_unref(detailTitleCrumbs)), 1)
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("ul", null, [
              _createElementVNode("li", {
                class: _normalizeClass({active: _unref(currentType) == '' && _unref(currentActive)}),
                onClick: _cache[2] || (_cache[2] = ($event: any) => (updateNewsList('')))
              }, "全部新闻", 2),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(typeList.value, (item, index) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: index,
                  class: _normalizeClass({active: _unref(currentType) == item.id}),
                  onClick: ($event: any) => (updateNewsList(item.id))
                }, _toDisplayString(item.name), 11, _hoisted_6))
              }), 128))
            ]),
            _createElementVNode("article", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("h1", null, _toDisplayString(_unref(detailTitle)), 1),
                _createElementVNode("h3", null, "发布时间：" + _toDisplayString(_unref(detailTime)) + " | 发布者：" + _toDisplayString(_unref(detailUser)), 1)
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", {
                  class: "ql-editor",
                  innerHTML: _unref(detailContent)
                }, null, 8, _hoisted_10),
                _createElementVNode("p", _hoisted_11, [
                  (_unref(prevTitle))
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        class: "fl",
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (changeDetail(1)))
                      }, "上一篇：" + _toDisplayString(_unref(prevTitle)), 1))
                    : _createCommentVNode("", true),
                  (_unref(nextTitle))
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 1,
                        class: "fr",
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (changeDetail(2)))
                      }, "下一篇：" + _toDisplayString(_unref(nextTitle)), 1))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("h1", _hoisted_15, _toDisplayString(_unref(detailTitle)), 1),
          _createElementVNode("h3", _hoisted_16, "发布时间：" + _toDisplayString(_unref(detailTime)) + " | 发布者：" + _toDisplayString(_unref(detailUser)), 1),
          _createElementVNode("div", {
            class: "ql-editor",
            innerHTML: _unref(detailContent)
          }, null, 8, _hoisted_17)
        ])
      ])
    ])
  ], 64))
}
}

})